import React from 'react';

const AdminIcon = ({ name, fallback, size = "16px", style = {} }) => {
  const iconPath = `/images/admin/icon_${name}.png`;
  
  return (
    <span style={{ 
      display: 'inline-flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      width: size,
      height: size,
      ...style 
    }}>
      <img 
        src={iconPath} 
        alt={name}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        // THE FAILSAFE: If image doesn't exist, show the emoji/character instead
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.parentNode.innerHTML = fallback;
        }}
      />
    </span>
  );
};

export default AdminIcon;